import React from 'react';
import { Box } from '@mui/material';
import { PieChart } from '@mui/x-charts/PieChart';
import { getDietQualityColor } from '../../lib/themes/generalTheme';

/**
 * @description MacronutrientPieChart component that displays a pie chart with three macronutrient slices
 *
 * @component
 *
 * @param {Object} props - Component props
 * @param {number} [props.carbohydrates=0] - Percentage of carbohydrates (0-100)
 * @param {number} [props.totalFat=0] - Percentage of total fat (0-100)
 * @param {number} [props.protein=0] - Percentage of protein (0-100)
 */
const MacronutrientPieChart = ({ carbohydrates = 0, totalFat = 0, protein = 0 }) => {
  // Calculate the total to ensure it's 100%
  const total = carbohydrates + totalFat + protein;
  const scale = total > 0 ? 100 / total : 0;

  // Calculate the scaled percentages
  const scaledCarbs = carbohydrates * scale;
  const scaledFat = totalFat * scale;
  const scaledProtein = protein * scale;

  const data = [
    { id: 0, value: scaledCarbs, label: 'Carbohydrates', color: getDietQualityColor(5) },
    { id: 1, value: scaledFat, label: 'Total Fat', color: getDietQualityColor(7) },
    { id: 2, value: scaledProtein, label: 'Protein', color: getDietQualityColor(9) },
  ];

  return (
    <Box
      sx={{
        margin: 0,
        padding: 0,
        width: '200px',
        height: 'auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '& .MuiPieArc-root': {
          stroke: 'none',
        },
      }}
    >
      <PieChart
        series={[
          {
            data,
            innerRadius: 0,
            outerRadius: 80,
            paddingAngle: 0,
            cornerRadius: 0,
            startAngle: -90,
            endAngle: 270,
            cx: 90,
            cy: 90,
            arcLabelRadius: 40,
            arcLabel: (item) => (item.value > 0 ? `${Math.round(item.value)}%` : ''),
            minAngle: 0,
            strokeWidth: 0,
          },
        ]}
        width={182}
        height={182}
        slotProps={{
          legend: { hidden: true },
        }}
      />
    </Box>
  );
};

export default MacronutrientPieChart;
